// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mobile from './Mobile'

var width = document.documentElement.clientWidth
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(width > 500 ? App : Mobile)
})



// WEBPACK FOOTER //
// ./src/main.js